module.exports = __webpack_public_path__ + "static/media/img9.1a4b75d5.png";